<template>
  <div :style="getWidth()">
    <div class="input-title"> {{title}} </div>
    <div v-if="type == 'text'" class="input-containear">
      <input type="text" v-on:keyup.enter="returnValue()" v-model="inputValue" class="input-value" :placeholder="placeholder">
      <span v-on:click="returnValue()" class="material-icons input-icon">search</span>
    </div>
    <div v-if="type == 'select' && !multiple" class="input-containear">
      <select v-model="selectValue" class="input-select-value">
        <option v-if="placeholder" value="" disabled selected> {{placeholder}} </option>
        <option v-for="(x, idx) in list" :value="x.value" :key="idx"> {{x.text}} </option>
      </select>
    </div>
    <div v-if="type == 'disabled'" class="input-containear">
      <select style="cursor: not-allowed;" disabled v-model="selectValue" class="input-select-value">
        <option v-if="placeholder" value="" disabled selected> {{placeholder}} </option>
        <option v-for="(x, idx) in list" :value="x.value" :key="idx"> {{x.text}} </option>
      </select>
    </div>
    <div v-if="type == 'select' && multiple" class="input-containear multiselect-wrapper" @click="toggleDropdown">
      <div class="multiselect-display">
        <span v-if="!selectValue.length" class="placeholder"> {{placeholder}} </span>
        <span v-else> {{displaySelected}} </span>
      </div>
      <div class="dropdown" v-show="dropdownOpen" @click.stop>
        <label v-for="(x, idx) in list" :key="idx" class="dropdown-item">
          <input 
            type="checkbox"
            :value="x.value" 
            v-model="selectValue"
          >
          <span> {{x.text}} </span>
        </label>
      </div>      
    </div>
  </div>
</template>

<script>
export default {
  name: 'StandardInput',
  props: ['title', 'width', 'type', 'list', 'value', 'action', 'placeholder', 'multiple'],
  data () {
    return {
      inputValue: '',
      selectValue: this.multiple ? [] : '',
      dropdownOpen: false,
    }
  },
  computed: {
    displaySelected() {
      const selected = this.list
        .filter(item => this.selectValue.includes(item.value))
        .map(item => item.text);

      return selected.join(', ');
    }
  },
  methods: {
    getWidth(){return 'width: ' + this.width},
    returnValue(){ this.action(this.inputValue) },
    onSelectChange(event) {
      if (this.multiple) {
        const values = Array.from(event.target.selectedOptions).map(o => o.value)
        this.selectValue = values
        this.action(values)
      } else {
        this.selectValue = event.target.value
        this.action(event.target.value)
      }
    },
    getWidth() {
      return 'width: ' + this.width;
    },
    returnValue() {
      this.action(this.inputValue);
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    closeDropdown() {
      if (this.$el.contains(e.target)) return;
      this.dropdownOpen = false;
    }
  },
  watch: {
    selectValue(newValue){
      this.action(newValue);
    },
    value(newValue) {
      if (!newValue) {
        this.selectValue = this.multiple ? [] : '';
      } else {
        this.selectValue = newValue;
      }
    }
  },
}
</script>

<style scoped>
.input-title{
  font-weight: 400;
  font-size: 1.5em;
  letter-spacing: 0.15px;
  color: #898989;
}
.input-containear{
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 1.5vh 0.7vw;
  display: flex;
  height: 6vh;
}
.input-value{
  border: none;
  flex: 1;
  font-weight: 400;
  font-size: 1.2em;
  letter-spacing: 0.15px;
  color: #B3B3B3;
  width: 90%;
}
.input-value:focus{
  border: none;
  outline: none;
}
.input-icon{
  color: #B3B3B3;
  cursor: pointer;
  font-size: 1.8em;
}
.input-select-value{
  border: none;
  font-weight: 400;
  font-size: 1.3em;
  letter-spacing: 0.15px;
  color: #B3B3B3;
  flex: 1;
  width: 100%;
  background-color: transparent;
}
.input-select-value:focus{
  border: none;
  outline: none;
}
.multiselect-wrapper {
  position: relative;
  cursor: pointer;
}

.multiselect-display {
  flex: 1;
  font-size: 1.3em;
  color: #B3B3B3;
  overflow-y: auto;
  border-color: #000;
}

.multiselect-display .placeholder {
  color: #B3B3B3;
}

.dropdown {
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  box-shadow: 0px 4px 14px rgba(0,0,0,0.1);
  padding: 8px;
  z-index: 20;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 4px;
  gap: 8px;
  cursor: pointer;
  font-size: 1.2em;
}

.dropdown-item:hover {
  background-color: #F4F4F4;
}

.dropdown-item input {
  cursor: pointer;
}

</style>